import React, { useState, useEffect } from "react";
import Header from "../../../header/Header";
import NextBtn from "../../../common/NextBtn";
import PrevBtn from "../../../common/PrevBtn";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import BaseURL from "../../../config/Baseurl";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../../common/Sidebar";
import { useTranslation } from 'react-i18next';

const Chapter01Screen13 = () => {
	const { t, i18n } = useTranslation();
	const navigate = useNavigate();





	return (
		<>
			<div className="wrapper page-auto bg-bd-2">
				<div
					className="fixed-header"

				>
					<div className="container-fluid cf-set">
						<Header leftChapter="1/2" percentage="50" star="50" />
					</div>
				</div>
				<div className="d-flex">
					<Sidebar />
					<div className="data-adjust">
						<div className="container-fluid cf-set">
							<div className="row align-items-top justify-content-between pt-20 mt-4">
								<div
									className="col-lg-8 wow fadeInDown"
									data-wow-duration="1s"
									data-wow-delay="0.2s"
								>
									{/* <h3 className="h3">{t('engage')}</h3> */}
									<p className="mb-2  mt-3">{t('M3chapter01Screen13Text1')} </p>

									<ul class="list-style-set list-circle mt-1">
										<li> <span dangerouslySetInnerHTML={{ __html: t('M3chapter01Screen13Text2') }}></span>	 </li>



										<li> <span dangerouslySetInnerHTML={{ __html: t('M3chapter01Screen13Text3') }}></span>  </li>


										<li> <span dangerouslySetInnerHTML={{ __html: t('M3chapter01Screen13Text4') }}></span>   </li>



										<li><span dangerouslySetInnerHTML={{ __html: t('M3chapter01Screen13Text5') }}></span>  </li>
										<li><span dangerouslySetInnerHTML={{ __html: t('M3chapter01Screen13Text6') }}></span> </li>
										<li><span dangerouslySetInnerHTML={{ __html: t('M3chapter01Screen13Text7') }}></span>  </li>
										<li><span dangerouslySetInnerHTML={{ __html: t('M3chapter01Screen13Text8') }}></span>  </li>
										<li><span dangerouslySetInnerHTML={{ __html: t('M3chapter01Screen13Text9') }}></span>  </li>


									</ul>

								</div>

								<div
									className="col-lg-4 wow fadeInDown"
									data-wow-duration="1s"
									data-wow-delay="0.2s"
								>
									<center>
										<img
											width="100%"
											draggable="false"
											src="/assets/img/md5/md-5-chap-1-13.png"
											alt=""
										/>
									</center>
								</div>



							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				className="button-fixed wow fadeInDown"
				data-wow-duration="1s"
				data-wow-delay="0.2s"
			>
				<div className="container-fluid cf-set">
					<div className="row">
						<div className="col-lg-12">
							<div className=" d-flex justify-content-end">

								<PrevBtn link="/module-03/chapter-01-screen-12" />
								<NextBtn link="/module-03/chapter-01-screen-15" text={t('CommonBtnGoNext')}/>
								{/* <BtnDisabled /> */}


							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Chapter01Screen13;
